import '../../sass/blocks/block-posts-carousel.scss';
import Swiper, { Navigation, Mousewheel, Pagination } from 'swiper';

function postsCarousel() {
    const $postsCarousel = document.querySelectorAll(
        '.section-posts-carousel .swiper'
    );
    if ($postsCarousel.length) {
        $postsCarousel.forEach(($carousel) => {
            // eslint-disable-next-line no-new
            new Swiper($carousel, {
                loop: true,
                speed: 400,
                loopedSlides: 20,
                slidesPerView: 0.925,
                centeredSlides: true,
                modules: [Navigation, Mousewheel, Pagination],
                grabCursor: true,
                spaceBetween: 13,
                breakpoints: {
                    600: {
                        slidesPerView: 1.5,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 23,
                    },
                },
                mousewheel: {
                    enabled: true,
                    sensitivity: 4,
                    forceToAxis: true,
                },
                navigation: {
                    prevEl: '.swiper-button-prev',
                    nextEl: '.swiper-button-next',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
        });
    }
}

window.document.addEventListener('DOMContentLoaded', postsCarousel, false);

// Initialize dynamic block preview (editor).
if (window.acf) {
    window.acf.addAction('render_block_preview', postsCarousel);
}
